var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// libs
import React from 'react';
// api
import { initiateLogingApi } from '@/includes/api/auth';
// constants
import { LOGIN_TYPE } from '@/constants/login';
// widgets
import SsoLogin from '@/pages/instamart/widgets/SsoLogin';
// styles
import styles from './Index.module.scss';
export default function EmployeeLoginPage() {
    const handleLogin = () => __awaiter(this, void 0, void 0, function* () {
        const redirectURI = yield initiateLogingApi(LOGIN_TYPE.INTERNAL);
        if (redirectURI) {
            window.location.href = redirectURI;
        }
    });
    return (React.createElement("div", { className: styles.container },
        React.createElement(SsoLogin, { handleLogin: handleLogin, className: styles.ssoLoginButton })));
}
